import request from "/utils/request";

const chapterAudio = (bookId, chapterId) => request
  .get(`/api/books/${bookId}/chapters/${chapterId}/audio`, { token: true })
  .then(response => response.url);

const sample = bookSlug => request
  .get("/api/books/sample_url/", {
    params: { slug: bookSlug },
    token: true
  });

const rateBook = (bookId, formData) => request
  .post(`/api/books/${bookId}/rate`, {
    body: formData,
    token: true
  });

const bookGalleryPartial = (categorySlug) => request
  .get("/api/books/books_in_brief_page", {
    params: {
      // eslint-disable-next-line camelcase
      category_slug: categorySlug
    }
  })
  .then(response => response.top_books_section);

export default {
  chapterAudio,
  sample,
  rateBook,
  bookGalleryPartial
};
